module.exports = __webpack_public_path__ + "img/azure_blue_squares.93a76482.png";